import { useNavigate } from "react-router-dom";
// import { useSidebar } from "./Siderbar";
import { toast } from "react-toastify";
// import { API_BASE } from "../Utils/constant";
// import { useAuth } from "../contexts/AuthContext";
// import { db } from "../Utils/firebase";
// import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useLogout } from "../Controllers/AuthController";
import useUserStore from "../zustand-stores/UserStore";
// import { retrieve } from "../helpers/StorageHelper";
// import { AUTH_TOKEN } from "../constants/localStorageKeys";
import useAuthStore from "../zustand-stores/AuthStore";
import { updateUserOnlineStatus } from "../hooks/useFireStore";
import { apiLogger } from "../Utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { remove } from "../helpers/StorageHelper";
import { USER_CURRENT_LEVEL } from "../constants/localStorageKeys";
import { getPostViewTracker } from "../helpers/PostViewTracker";
import { useBatchTrackViews } from "../Controllers/Tribe/TribePostController";

const LogoutButton = ({ sidebarState }) => {
  // Accept sidebarState as prop
  const navigate = useNavigate();
  const { mutate: logout, isPending: logoutPending } = useLogout();
  const { user, removeUser } = useUserStore();
  const { clearAuthSession, authSession } = useAuthStore();
  const queryClient = useQueryClient();
  const { mutateAsync: batchTrackViews } = useBatchTrackViews();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogoutError = (error) => {

    updateUserOnlineStatus(user, false);
    try { queryClient.clear(); } catch (e) { console.warn('Failed to clear query cache on logout', e); }
    remove(USER_CURRENT_LEVEL);
    clearAuthSession();
    removeUser();
    // toast.error("Logout failed! Logged out locally.");
    apiLogger.apiError("Logout failed", error);
    navigate("/login");
  }

  const handleSuccessfulLogout = () => {

    updateUserOnlineStatus(user, false);
    try { queryClient.clear(); } catch (e) { console.warn('Failed to clear query cache on logout', e); }
    remove(USER_CURRENT_LEVEL);
    clearAuthSession();
    removeUser();
    // toast.success("Logout successful!");
    navigate("/login");
  }

  const handleLogout = async () => {

    
    // Flush pending post views before logout
    try {
      const tracker = getPostViewTracker();
      const pendingViews = tracker.getBatchQueue();
      
      if (pendingViews.length > 0) {

        await tracker.flushBatch(async (payload) => {
          const response = await batchTrackViews(payload);
          return response;
        });

      }
    } catch (error) {
      console.error("Failed to flush pending views before logout:", error);
      // Continue with logout even if flush fails
    }
    
    if (!authSession) {
      console.warn("No token found. Logging out locally.");
      updateUserOnlineStatus(user, false);
      try { queryClient.clear(); } catch (e) { console.warn('Failed to clear query cache on logout', e); }
      remove(USER_CURRENT_LEVEL);
      clearAuthSession();
      removeUser();
      // toast.success("Logged out locally.");
      navigate("/login");
      return;
    }

    logout(undefined, {
      onSuccess: () => handleSuccessfulLogout(),
      onError: (error) => handleLogoutError(error),
    });
  };

  return (
    <li className="nav-item">
      <button
        className="nav-link text-body-b1"
        onClick={handleLogout}
        style={{
          justifyContent: !isMobile && sidebarState === "collapsed" ? "center" : "",
          width: "100%",
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H15.25C15.66 11.25 16 11.59 16 12C16 12.41 15.66 12.75 15.25 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z"
            fill="currentColor"
          />
          <path
            d="M4.56043 11.2498L6.63043 9.17984C6.78043 9.02984 6.85043 8.83984 6.85043 8.64984C6.85043 8.45984 6.78043 8.25984 6.63043 8.11984C6.34043 7.82984 5.86043 7.82984 5.57043 8.11984L2.22043 11.4698C1.93043 11.7598 1.93043 12.2398 2.22043 12.5298L5.57043 15.8798C5.86043 16.1698 6.34043 16.1698 6.63043 15.8798C6.92043 15.5898 6.92043 15.1098 6.63043 14.8198L4.56043 12.7498H9.00043V11.2498H4.56043Z"
            fill="currentColor"
          />
        </svg>
        {!isMobile ? (
          sidebarState !== "collapsed" && (
            <>
              <span className="nav-text">Logout</span>
              <img alt="Settings active indicator" className="active-state-img" src="/icons/active-state-mark.svg" />
            </>
          )
        ) : (
          <>
            <span className="nav-text">Logout</span>
            <img alt="Settings active indicator" className="active-state-img" src="/icons/active-state-mark.svg" />
          </>
        )}{" "}
        <img alt="image-alt" className="active-state-img" src="/icons/active-state-mark.svg" />
      </button>
    </li>
  );
};

export default LogoutButton;
